export class ListBackupPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupPolicies",
            "baseName": "backupPolicies",
            "type": "Array<BackupPolicyConfig>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
